module.exports = __webpack_public_path__ + "static/media/join-in-img5-1.13acd4bb.jpg";